export default "data:image/gif;base64,R0lGODlhEgAMAPEAAP///wAA//8AAOXl5SH5BAAAAAAALAAAAAASAAwAAAIdnI+JwO0PDJxN0jmC3rz7D4bi6AnmiabqyrbuqxYAOw=="